import React, { useEffect, useRef } from "react";
import LanguageStringResolver from "../fields/language/LanguageStringResolver";
import getClientConfig from "../../utils/getClientConfig";
import { FeatureFlagEnum } from "../../utils/enums";
import { SToasts } from '@avalara/skylab-sdk/react';

const GetFlagValue = (exportFor) => {
  const { featureFlags } = getClientConfig();
  return featureFlags?.[FeatureFlagEnum[exportFor]];
};

const ExportAll = (props) => {
  const {
    exportClick,
    exportLabel,
    toastType,
    toastTitle,
    toastDetails,
    toastActionText,
    toastActionHandler,
    exportFor,
    elementType,
    showToast,
    elementClassName,
    onCloseClick,
    testId
  } = props;
  const enableFeature = GetFlagValue(exportFor);
  if (!enableFeature) return <></>;
  const toastRef = useRef();

  const createToast = () => {
    const toastData = {
      text: toastTitle,
      details: toastDetails,
      id: "export-all",
      status: toastType && toastType.toLowerCase(),
      persistent: true,
    };
    if (toastActionText && toastActionHandler) {
      toastData.actionText = toastActionText;
      toastData.actionHandler = toastActionHandler;
    }
    toastRef.current.createToast(toastData);
  };

  useEffect(() => {
    const handleDismiss = () => {
      onCloseClick();
    };
    window.addEventListener('s-dismiss', handleDismiss);
    return () => window.removeEventListener('s-dismiss', handleDismiss);
  }, [onCloseClick]);

  useEffect(() => {
    if (showToast && toastTitle && toastRef.current) {
      createToast();
    }
  }, [showToast, toastTitle, toastDetails, toastActionText, toastActionHandler]);

  const renderElementAsPerElementType = (data) => {
    if (data && data.toLowerCase() === "inline") {
      return (
        <span className={elementClassName} data-testid="wrapper-export-all-link">
          <a data-testid={testId ? testId : "export-all-link"} onClick={exportClick}>
            {<LanguageStringResolver string={exportLabel} />}
          </a>
        </span>
      );
    } else {
      return (
        <button className={elementClassName ? elementClassName : "margin-right-sm button secondary"} data-testid={testId ? testId : "export-all-button"} onClick={exportClick}>
          {<LanguageStringResolver string={exportLabel} />}
        </button>
      );
    }
  };

  return (
    <>
      {renderElementAsPerElementType(elementType)}
      {showToast ? <SToasts ref={toastRef} data-testid="export-all-toast" /> : null}
    </>
  );
};


ExportAll.defaultProps = {
  exportLabel: "Export",
  elementType: "btn",
  showToast: true,
  toastType: "success",
  elementClassName: undefined,
  testId: undefined
};

export default ExportAll;
